import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbCalendar, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProductoService } from '@abm/producto/producto.service';
import { TipoEstadoPrecio } from '@shared/enums/tipoEstadoPrecio';
import { Producto } from '@shared/models/abm/Producto';
import { Aeroplanta } from '@shared/models/stock/Aeroplanta';
import { BonificacionRecargo } from '@shared/models/precios/BonificacionyRecargo';
import { MessageService } from '@shell/message.service';
import { PreciosService } from '../../precios.service';
import { ModalNuevaBorComponent } from '../modal-nueva-bor/modal-nueva-bor.component';
import { EstadoPrecio } from '@shared/models/precios/EstadoPrecio';
import { ModalNuevaByrPorSurtidorComponent } from '../modal-nueva-byr-por-surtidor/modal-nueva-byr-por-surtidor.component';
import { ListaAeroplantasComponent } from '@shared/lista-aeroplantas/lista-aeroplantas.component';
import { ProductosByrComponent } from './productos-byr/productos-byr.component';
import { ClientesByrComponent } from './clientes-byr/clientes-byr.component';
import { ModalImportarByrComponent } from '../modal-importar-byr/modal-importar-byr.component';
import { MotivosObservacionesComponent } from '@shared/components/motivos-observaciones/motivos-observaciones.component';
import { ListaExpendedorasComponent } from '@shared/lista-expendedoras/lista-expendedoras.component';
import { StockService } from '@stock/stock.service';
import { TipoVigencia } from '@shared/enums/tipoVigencia';
import { TipoCantidadPaginado } from '@shared/enums/TipoCantidadPaginado';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { environment } from '@environments';
import { TipoBonificacionRecargo } from '@shared/enums/TipoBonificacionRecargo';
import { TipoModalObservacion } from "@shared/enums/TipoModalObservacion";
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { RenovarByrComponent } from './renovar-byr/renovar-byr.component';
import { Cliente } from '@shared/models/precios/Cliente';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-listado-byr',
  templateUrl: './listado-byr.component.html',
  styleUrls: ['./listado-byr.component.css']
})
export class ListadoByrComponent implements OnInit {
  esperandoCarga: boolean = false;
  messageByR: string = 'C A R G A N D O . . .';
  aeroplantas: Aeroplanta[] = [];
  checkAeroplanta: any[] = [];
  productosParaCheckear: any[] = [];
  productos: Producto[];
  desactivandoBoR: boolean = false;
  seleccionadaBor: BonificacionRecargo;
  listaClientesFiltro: Cliente[] = [];

  vigencias = [
    { nombre: "Vigentes", seleccionado: true },
    { nombre: "Vencidos", seleccionado: false },
    { nombre: "Futuros", seleccionado: false }
  ];
  estados = [
    { nombre: "Pendiente", seleccionado: true },
    { nombre: "Aprobado", seleccionado: true },
    { nombre: "Rechazado", seleccionado: false }
  ];

  searchForm = new UntypedFormGroup({
    busqueda: new UntypedFormControl(''),
  });

  bonificacionyRecargo: BonificacionRecargo[];
  bonificacionyRecargoFiltrado: BonificacionRecargo[];

  modelFecha: NgbDateStruct;
  modelHora: any;

  page = 1;
  pageSize = TipoCantidadPaginado.NORMAL;
  collectionSize = 0;
  actualizandoByr: boolean = false;
  errorByr: boolean = false;
  seleccionRenovar: boolean = false;

  TipoUsuario = TipoUsuario;

  constructor(
    private spinner: NgxSpinnerService,
    private calendar: NgbCalendar,
    private preciosService: PreciosService,
    private productoService: ProductoService,
    private messageService: MessageService,
    private activeModal: NgbModal,
    private modalService: NgbModal,
    private stockService: StockService,
    public authService: AuthService,
    private exportExcelService: ExportExcelServiceService,
    private datePipe: DatePipe) { }

  ngOnInit() {

    this.modelFecha = this.calendar.getToday();
    const horaActual = new Date();
    this.modelHora = { hour: horaActual.getHours(), minute: horaActual.getMinutes(), second: horaActual.getSeconds() };

    this.getTodasLasAeroplantas();
    this.getTodosLosProductos();
    this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
    this.searchForm.valueChanges.subscribe(() => this.filtrarByR());
  }

  // llamadas al service

  getTodasLasAeroplantas() {
    this.stockService.obtenerAeroplantasStock()
      .subscribe(result => {
        this.aeroplantas = result;
        for (const a of this.aeroplantas) {
          this.checkAeroplanta.push({ "codigo": a.codigoAeroplanta, "seleccionado": false });
        }
      });
  }

  getTodosLosProductos() {
    this.productos = [];
    this.productoService.obtenerProductos()
      .subscribe(result => {
        this.productos = result;
        this.productosParaCheckear = [];
        for (const prod of this.productos) {
          this.productosParaCheckear.push({ "nombre": prod.nombreProducto, "codigo": prod.codigoProducto, "seleccionado": false });
        }
      });
  }
  /*
    getBonificacionesyRecargos() {
      this.esperandoCarga = true;
      this.bonificacionyRecargo = [];
      this.bonificacionyRecargoFiltrado = [];
      this.spinner.show('spinnerGrafico');
      this.preciosService.getBonificacionesyRecargos(null)
        .subscribe(result => {
  
          result.forEach(b => {
  
            if(b.aprobadoPor && b.aprobadoPor.indexOf(',') > -1) b.aprobadoPor = JSON.parse(b.aprobadoPor.replace(/'/g,'"')).nombresCompletos;
  
            if(b.solicitadoPor && b.solicitadoPor.indexOf(',') > -1) b.solicitadoPor = JSON.parse(b.solicitadoPor.replace(/'/g,'"')).NombresCompletos;
          });
  
          this.bonificacionyRecargo = result;
          this.bonificacionyRecargoFiltrado = result;
          this.filtrarByR();
          this.spinner.hide('spinnerGrafico');
          this.esperandoCarga = false;
        }, (err: ErrorModel) => {
          this.esperandoCarga = false;
          this.spinner.hide("spinnerGrafico");
          this.messageService.showErrorMessage("Error al obtener bonificaciónes y recargos.");
        });
    }
  */
  getBonificacionesyRecargosPaginadas(page: number, size: number, actualizacion?: boolean) {

    if (actualizacion) {
      this.esperandoCarga = false;
      this.actualizandoByr = true;
    } else {
      this.esperandoCarga = true;
    }

    this.spinner.show('spinnerGrafico');
    this.bonificacionyRecargo = [];
    this.bonificacionyRecargoFiltrado = [];

    this.preciosService.getBonificacionesyRecargos(page, size,
      this.estadosSeleccionado(),
      this.aeroplantasSeleccionada(),
      this.productosSeleccionado(),
      this.vigenciasSeleccionada(),
      this.formatDate(this.modelFecha.year, this.modelFecha.month, this.modelFecha.day, 0, 0),
      null)
      .subscribe(pageList => {

        this.page = pageList.pageNumber;
        this.pageSize = pageList.pageSize;
        this.collectionSize = pageList.totalItemCount;
        const result = pageList.items;

        this.listaClientesFiltro = [];
        result.forEach(b => {
          b.seleccionadoUi = false;
          if (b.clientes) b.clientes.forEach(c => {
            const duplicado = this.listaClientesFiltro.find(cliente => cliente.razonSocial == c.razonSocial);
            if (!duplicado) this.listaClientesFiltro.push(c);
          });
          if (b.aprobadoPor && b.aprobadoPor.indexOf(',') > -1) b.aprobadoPor = JSON.parse(b.aprobadoPor.replace(/'/g, '"')).nombresCompletos;
          if (b.solicitadoPor && b.solicitadoPor.indexOf(',') > -1) {
            const bonificacionSolicitadaPor =  JSON.parse(b.solicitadoPor.replace(/'/g, '"'));
            b.solicitadoPor = bonificacionSolicitadaPor.nombresCompletos ? bonificacionSolicitadaPor.nombresCompletos : bonificacionSolicitadaPor.NombresCompletos;
          }
        });

        if (actualizacion) {
          this.actualizandoByr = false;
        } else {
          this.esperandoCarga = false;
        }

        this.bonificacionyRecargo = result;
        this.bonificacionyRecargoFiltrado = result;
        this.spinner.hide('spinnerGrafico');
      }, () => {
        if (actualizacion) {
          this.actualizandoByr = false;
        } else {
          this.esperandoCarga = false;
        }
        this.spinner.hide('spinnerGrafico');
        this.messageService.showErrorMessage("Error al obtener bonificaciónes y recargos.");
      });
  }

  chequearSeleccion() {
    this.seleccionRenovar = this.bonificacionyRecargoFiltrado.some(byr => {
      return byr.seleccionadoUi == true;
    })
  }

  resetearSeleccion() {
    this.bonificacionyRecargoFiltrado.forEach(byr => byr.seleccionadoUi = false);
  }

  estadosSeleccionado() {
    const estadosSeleccionados: number[] = [];

    if (this.estados.some(e => e.seleccionado)) {
      if (this.estados[0].seleccionado) {
        estadosSeleccionados.push(TipoEstadoPrecio.Pendiente);
      }
      if (this.estados[1].seleccionado) {
        estadosSeleccionados.push(TipoEstadoPrecio.Aprobado);
      }
      if (this.estados[2].seleccionado) {
        estadosSeleccionados.push(TipoEstadoPrecio.Rechazado);
      }

      return estadosSeleccionados;
    } else {
      return null;
    }
  }

  aeroplantasSeleccionada() {
    if (this.checkAeroplanta.some(a => a.seleccionado)) {
      return this.checkAeroplanta.filter(a => a.seleccionado).map(a => a.codigo);
    } else {
      return null;
    }
  }

  productosSeleccionado() {
    if (this.productosParaCheckear.some(p => p.seleccionado)) {
      return this.productosParaCheckear.filter(p => p.seleccionado).map(p => p.codigo);
    } else {
      return null;
    }
  }

  vigenciasSeleccionada() {
    const vigenciasSeleccionadas: number[] = [];

    if (this.vigencias.some(v => v.seleccionado)) {
      if (this.vigencias[0].seleccionado) {
        vigenciasSeleccionadas.push(TipoVigencia.Vigente);
      }
      if (this.vigencias[1].seleccionado) {
        vigenciasSeleccionadas.push(TipoVigencia.Vencido);
      }
      if (this.vigencias[2].seleccionado) {
        vigenciasSeleccionadas.push(TipoVigencia.Futuro);
      }

      return vigenciasSeleccionadas;
    } else {
      return null;
    }
  }

  filtrarClientes() {
    const clientesAFiltrar = this.listaClientesFiltro.filter(c => c.seleccionado);
    if(clientesAFiltrar.length > 0) {
      this.bonificacionyRecargoFiltrado = this.bonificacionyRecargoFiltrado.filter(byr =>
        byr.clientes && byr.clientes.some(cliente =>
          clientesAFiltrar.some(c => c.razonSocial === cliente.razonSocial)
        )
      );
    } else this.filtrarByR();
  }

  desactivarBoR(seleccion: BonificacionRecargo, i) {

    this.desactivandoBoR = true;
    const listaIdsSeleccionados: string[] = [];
    listaIdsSeleccionados.push(seleccion.id);

    const estado = new EstadoPrecio();
    estado.responsable = this.preciosService.obtenerStringResponsableV2();
    estado.activo = seleccion.estado.activo == 1 ? 0 : 1;
    estado.estadoPrecio = seleccion.estado.estadoPrecio;

    this.preciosService.cambiarEstadoByR(estado, listaIdsSeleccionados)
      .subscribe(() => {
        const estadoNuevo = seleccion.estado.activo == 1 ? 0 : 1;
        this.bonificacionyRecargoFiltrado[i].estado.activo = estadoNuevo;
        this.esperandoCarga = false;
        const estado = seleccion.estado.activo == 1 ? 'activo' : 'desactivo';
        this.messageService.showSuccessLongMessage("Se " + estado + " la bonificacion y recargo.");
        this.desactivandoBoR = false;
      },
        () => {
          this.desactivandoBoR = false;
          this.messageService.showErrorMessage("Error al cambiar estado de bonificación y recargo.");
        });


    /*this.desactivandoBoR = true;
    let estadoPrecioTipo = seleccion.estado.estadoPrecio;
    let activo: number;
    seleccion.estado.activo == 1 ? activo = 0 : activo = 1;

    seleccion.estado = new EstadoPrecio;
    seleccion.estado.activo = activo;
    seleccion.estado.estadoPrecio = estadoPrecioTipo;
    seleccion.estado.responsable = this.preciosService.obtenerStringResponsableV2();
    this.preciosService.putBonificacionesyRecargos(seleccion)
      .subscribe(result => {
        this.emitirCartelActivacion(seleccion.estado.activo, seleccion.tipo);
        this.desactivandoBoR = false;
      }, () => {
        this.messageService.showErrorMessage('Hubo un error al desactivar la bonificación o recargo.');
        this.desactivandoBoR = false;
      });*/
  }


  // form

  filtrarByR() {
    const searchTerm = this.busquedas.value.toLocaleLowerCase();
  
    this.bonificacionyRecargoFiltrado = this.bonificacionyRecargo.filter(a => {

      let agregar = false;
  
      if (a.clientes && a.clientes.length > 0) {
        agregar = a.clientes.some(c => 
          c.cta_SGC.toLocaleLowerCase().includes(searchTerm) || 
          c.razonSocial.toLocaleLowerCase().includes(searchTerm)
        );
      }
  
      agregar = agregar || 
                (a.codigoProducto?.toLocaleLowerCase().includes(searchTerm)) || 
                (a.valor.toString().toLocaleLowerCase().includes(searchTerm));
  
      return agregar;
    });
  }
  
  
  
  formatDate(year, month, day, hour, minute): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':59';
  }

  emitirCartelActivacion(activo: number, tipo: number) {
    let cartelActivo: string = "desactivad";
    if (activo === 1) {
      cartelActivo = "activad";
    }
    if (tipo === 0) {
      cartelActivo = cartelActivo.concat('a');
      this.messageService.showSuccessLongMessage('La bonificación fue ' + cartelActivo + ' con exito.');
    }
    else {
      cartelActivo = cartelActivo.concat('o');
      this.messageService.showSuccessLongMessage('El recargo fue ' + cartelActivo + ' con exito.');
    }
  }

  modificacionBoR(i: number) {
    this.seleccionadaBor = this.bonificacionyRecargoFiltrado[i];
    if (this.seleccionadaBor.tipoBonificacionRecargo === TipoBonificacionRecargo.Producto) {
      this.modificarBonificacionORecargo();
    }
    else {
      this.modificarBonificacionORecargoSurtidor();
    }

  }

  modificarBonificacionORecargo() {
    const modalRef = this.activeModal.open(ModalNuevaBorComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.seleccionadaBoR = this.seleccionadaBor;
    if (this.seleccionadaBor != null) {
      modalRef.result.then(() => {
        this.page = 1;
        this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
      });
    } else {
      modalRef.result.then(() => {
        this.page = 1;
        this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
      });
    }

  }

  modificarBonificacionORecargoSurtidor() {
    const modalRef = this.activeModal.open(ModalNuevaByrPorSurtidorComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.BonifRecargoSeleccionada = this.seleccionadaBor;
    if (this.seleccionadaBor != null) {
      modalRef.result.then(() => {
        this.page = 1;
        this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
      })
    } else {
      modalRef.result.then(() => {
        this.page = 1;
        this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
      })
    }
  }

  agregarBonificacionORecargoProducto() {
    this.seleccionadaBor = null;
    const modalRef = this.activeModal.open(ModalNuevaBorComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.seleccionadaBoR = this.seleccionadaBor;
    if (this.seleccionadaBor != null) {
      modalRef.result.then(() => {
        this.page = 1;
        this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
      });
    } else {
      modalRef.result.then(() => {
        this.page = 1;
        this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
      });
    }

  }

  agregarBonificacionORecargoSurtidor() {
    this.seleccionadaBor = null;
    const modalRef = this.activeModal.open(ModalNuevaByrPorSurtidorComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.BonifRecargoSeleccionada = this.seleccionadaBor;
    if (this.seleccionadaBor != null) {
      modalRef.result.then(() => {
        this.page = 1;
        this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
      })
    } else {
      modalRef.result.then(() => {
        this.page = 1;
        this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
      })
    }
  }

  importarByR() {
    const modalRef = this.activeModal.open(ModalImportarByrComponent, { centered: true, size: "lg", backdrop: "static" });
    modalRef.result.then(() => {
      this.ngOnInit();
    })
  }

  onRefreshClick() {
    this.getBonificacionesyRecargosPaginadas(this.page, this.pageSize)
  }

  verClientes(listaDeClientes) {
    const modalRef = this.modalService.open(ClientesByrComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.clientes = listaDeClientes;
  }

  verProductos(listaDeProductos) {
    const modalRef = this.modalService.open(ProductosByrComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.productos = listaDeProductos;
  }

  verAeroplantas(listaDeAeroplantas) {
    const modalRef = this.modalService.open(ListaAeroplantasComponent, { centered: true, backdrop: 'static' });

    const lista = this.convertirListaDeCodigosEnListaDeAeroplantas(listaDeAeroplantas);
    modalRef.componentInstance.aeroplantas = lista;
  }

  verSurtidores(listaDeSurtidores) {
    const modalRef = this.modalService.open(ListaExpendedorasComponent, { centered: true, backdrop: 'static' });

    modalRef.componentInstance.aeroplantas = listaDeSurtidores;
  }

  verMotivos(motivos) {
    const modalRef = this.modalService.open(MotivosObservacionesComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = "Motivos";
    modalRef.componentInstance.motivos = motivos;
    modalRef.componentInstance.tipoObservacion = TipoModalObservacion.ByR;
  }

  convertirListaDeCodigosEnListaDeAeroplantas(lista: string[]): Aeroplanta[] {
    const resultado: Aeroplanta[] = [];

    if (lista != null) {
      lista.forEach(codigo => {
        let agregar: Aeroplanta;
        if (isNaN(Number(codigo))) {
          agregar = this.aeroplantas.find(e => e.codigoAeroplanta === codigo);
        } else {
          agregar = this.aeroplantas.find(e => e.numeroAeroplanta === codigo);
        }

        resultado.push(agregar);
      });

    }
    return resultado;
  }

  renovarByR() {
    const byr = [];
    this.bonificacionyRecargoFiltrado.forEach(b => {
      if (b.seleccionadoUi) byr.push(b);
    });
    if (byr.length > 0) {
      const modalRef = this.modalService.open(RenovarByrComponent);
      modalRef.componentInstance.byr = byr;
      modalRef.result.then((result) => {
        if (result) {
          this.messageService.showSuccessMessage('Las bonificaciones fueron renovadas correctamente');
          this.resetearSeleccion();
        } else {
          this.messageService.showErrorMessage('Ha habido un error al renovar las bonificaciones');
        }
      });
    }
  }

  exportarExcel() {
    const byrExcel = [];
    this.bonificacionyRecargoFiltrado.forEach(byr => {

      let clientesExcel = "";
      let clientesRazonSocial = "";
      if (byr.clientes) {
        byr.clientes.forEach(c => {
          clientesExcel = clientesExcel + c.cta_SGC + ";";
          clientesRazonSocial = clientesRazonSocial + c.razonSocial + ";";
        });
        clientesExcel = clientesExcel.slice(0, -1); //elimina ; final
      }

      let productosExcel = "";
      let codigosProductoExcel = "";
      if (byr.productos) {
        byr.productos.forEach(p => {
          productosExcel = productosExcel + p.nombreProducto + ";";
          codigosProductoExcel = codigosProductoExcel + p.codigoProducto + ";";
        });
        productosExcel = productosExcel.slice(0, -1);
        codigosProductoExcel = codigosProductoExcel.slice(0, -1);
      }

      let aeroplantasExcel = "";
      let codigosAeroplantasExcel = "";
      if (byr.codigosAeroplantas) {
        byr.codigosAeroplantas.forEach(a => {
          const aeroplanta = this.aeroplantas.find(aeroplanta => aeroplanta.codigoAeroplanta == a);
          if(aeroplanta) {
            aeroplantasExcel = aeroplantasExcel + aeroplanta.nombre + " " + "(" + aeroplanta.codigoAeroplanta + ")"+ ";";
            codigosAeroplantasExcel = codigosAeroplantasExcel + aeroplanta.numeroAeroplanta + ";";
          } else {
            aeroplantasExcel = aeroplantasExcel + ";";
            codigosAeroplantasExcel = codigosAeroplantasExcel + ";";
          } 

          
        });
        aeroplantasExcel = aeroplantasExcel.slice(0, -1);
        codigosAeroplantasExcel = codigosAeroplantasExcel.slice(0, -1);
      }

      let surtidoresExcel = "";
      if (byr.expendedoras) {
        byr.expendedoras.forEach(e => surtidoresExcel = surtidoresExcel + (e.nombreExpendedora + " (" + e.codigoExpendedora + ");"));
        surtidoresExcel = surtidoresExcel.slice(0, -1);
      }

      const fechaDesde = this.datePipe.transform(byr.fechaDesde, 'short');
      const fechaHasta = this.datePipe.transform(byr.fechaHasta, 'short');
    
      const bonificacionYRecargoExcel = {
        Estado: TipoEstadoPrecio[byr.estado.estadoPrecio],
        RazonSocialCliente: clientesRazonSocial,
        Clientes: clientesExcel,
        NombreProducto: productosExcel,
        Productos: codigosProductoExcel,
        NombreAeroplanta: aeroplantasExcel, 
        Aeroplantas: codigosAeroplantasExcel,
        Surtidores: surtidoresExcel,
        FechaDesde: fechaDesde,
        FechaHasta: fechaHasta,
        Valor: byr.valor,
        Tipo: this.obtenerLeyendasBonificacion(byr.tipo),
        Solicitado: byr.solicitadoPor,
        Aprobado: byr.aprobadoPor,
        Motivo: byr.motivo
      }

      byrExcel.push(bonificacionYRecargoExcel);

    });

    this.exportExcelService.exportAsExcelFile(byrExcel, 'Listado Bonificaciones y Recargos');
  }

  // getters

  obtenerLeyendaEstado(estado) {
    if (estado != null) {
      if (estado.estadoPrecio == TipoEstadoPrecio.Aprobado) {
        return "Aprobado";
      } else if (estado.estadoPrecio == TipoEstadoPrecio.Rechazado) {
        return "Rechazado";
      } else if (estado.estadoPrecio == TipoEstadoPrecio.Pendiente) {
        return "Pendiente";
      }
    }
  }

  obtenerLeyendasBonificacion(bonif: number) {
    if (bonif == 0) {
      return 'Bonificación';
    } else {
      return 'Recargo';
    }
  }

  obtenerCiudad(codAeroplanta: string, i: number) {
    const codArray = [codAeroplanta];
    const aeroplantas = this.convertirListaDeCodigosEnListaDeAeroplantas(codArray);
    return aeroplantas[i].nombre;
  }

  get busquedas() {
    return this.searchForm.get("busqueda");
  }

  get habilitarBotones() {
    return !this.authService.hasRole(TipoUsuario.COMERCIAL) && (environment.name == 'production') || (environment.name != 'production')
  }

  public onPageChange = (pageNumber) => {
    this.bonificacionyRecargoFiltrado = [];
    this.getBonificacionesyRecargosPaginadas(pageNumber, this.pageSize, true);
  }
}
